import { Box, Grid2, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import { toInteger } from 'lodash';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';
import ExpenseTextField from './ExpenseTextField';
import { valueAsNumber, valueAsText } from '../../Utils/ValueAsUtils';
import { COLORS } from '../../../utils/Application_Constants';
import { getVaultExpensesById } from '../../Services/ExpenseService';

const useStyles = makeStyles((theme) => ({
    formHeader: {
        borderBottom: `1px solid ${COLORS.LT_MIDNIGHT25}`,
        paddingBottom: 8,
        marginBottom: 16,
    },
}));

const ChargeDetailsForm = (props) => {
    const classes = useStyles();
    const { expense, index, mode } = props;
    const { control, errors } = useFormContext();

    const [vaultTotalCharge, setVaultTotalCharge] = useState({});

    useEffect(() => {
        if (mode === 'vault' && expense && expense.id) {
            const { id } = expense;
            const fetchExpenseById = async () => {
                try {
                    const res = await getVaultExpensesById(id);
                    setVaultTotalCharge(res);
                } catch (e) {
                    console.log(e);
                }
            };
            fetchExpenseById();
        }
    }, [mode, expense]);

    const renderAmount = (onChange, value) => (
        <ExpenseTextField
            id="totalCharge"
            onChange={(e) => onChange(valueAsNumber(e.target.value))}
            value={
                mode === 'vault'
                    ? vaultTotalCharge.totalCharge
                        ? vaultTotalCharge.totalCharge.toFixed(2)
                        : 0
                    : value !== 0
                    ? value.toFixed(2)
                    : 0
            }
            label="Amount"
            placeholder="Amount"
            required={mode !== 'cc' && expense?.status !== ExpenseStatusValuesEnum.Abandoned}
            error={Boolean(errors.expenseEntries?.[index]?.totalAmount)}
            helperText={errors.expenseEntries?.[index]?.totalAmount?.message}
            startAdornment={
                <Box sx={{ marginRight: '2px', marginLeft: '10px', fontSize: '14px' }}>$</Box>
            }
            endAdornment={
                <Box
                    sx={{
                        alignItems: 'center',
                        alignSelf: 'stretch',
                        background: COLORS.LT_MIDNIGHT250,
                        display: 'flex',
                        fontSize: '14px',
                        paddingLeft: '10px',
                        paddingRight: '10px',
                    }}
                >
                    <Box>$USD</Box>
                </Box>
            }
            disabled
        />
    );

    return (
        <div>
            <Typography variant="h5" component="h5" className={classes.formHeader}>
                Charge Details
            </Typography>
            <Grid2 container spacing={3}>
                <Grid2 item size={{ xs: 12, sm: 6 }}>
                    <Controller
                        control={control}
                        name={`expenseEntries[${index}].totalAmount`}
                        defaultValue={expense.amount}
                        rules={{
                            required:
                                mode !== 'cc' &&
                                expense?.status !== ExpenseStatusValuesEnum.Abandoned
                                    ? 'Amount is required'
                                    : false,
                        }}
                        render={({ onChange, value }) => renderAmount(onChange, value)}
                    />
                </Grid2>
            </Grid2>
        </div>
    );
};

export default ChargeDetailsForm;
